import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Calendar } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import PageHero from '../components/PageHero';
import TrialCTA from '../components/TrialCTA';
import { ARTICLES, readingTime, formatDate } from '../data/blog';

export default function BlogIndex() {
  return (
    <>
      <PageHero
        eyebrow="Le blog"
        title="Conseils &"
        accent="actus Hyrox"
        img="hxRunStart"
        subtitle="Préparation, technique des stations, nutrition, mental : tous nos guides pour progresser sur l'Hyrox à Toulouse et Colomiers, signés par les coachs Hybrid."
      />

      <section className="py-14 md:py-28 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 100}>
              <Link
                to={`/blog/${a.slug}`}
                className="hx-card group rounded-md overflow-hidden h-full flex flex-col"
              >
                <div className="h-52 overflow-hidden relative">
                  <img
                    src={a.featured}
                    alt={a.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-[#131313]/20 to-transparent" />
                  <span className="absolute top-4 left-4 px-2.5 py-1 bg-accent text-black font-cond text-xs tracking-widest rounded-sm">
                    {a.keyword}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="font-display text-xl md:text-2xl leading-[1.05] mb-3 group-hover:text-accent transition-colors">
                    {a.title}
                  </h2>
                  <p className="text-[var(--hx-muted)] text-sm leading-relaxed flex-1">
                    {a.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-5 text-[var(--hx-muted)] font-cond text-xs tracking-wider">
                    <span className="inline-flex items-center gap-1.5">
                      <Calendar size={13} className="text-accent" />
                      {formatDate(a.date)}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <Clock size={13} className="text-accent" />
                      {readingTime(a.content)} min
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-accent font-cond text-sm tracking-wider mt-5">
                    Lire l'article{' '}
                    <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
